/**
 * Status Configuration
 * All status lists are defined here and can be easily edited
 */

// Enquiry Status Configuration
export const ENQUIRY_STATUS = [
  'Initial Discussion Pending',
  'Require Additional Information',
  'Requested Site Visit',
  'Follow Up Scheduled',
  'Follow Up Missed',
  'Demo Scheduled',
  'Demo Missed',
  'Quotation Pending',
  'Quotation Sent',
  'Not Interested',
  'Not Interested - Price High',
  'On Hold',
  'No Response',
  'Closed',
  'Others'
];

// Quotation Status Configuration
export const QUOTATION_STATUS = [
  'Follow Up Scheduled',
  'Follow Up Missed',
  // 'Quotation Sent',
  'Negotiation Ongoing',
  'Revised Quotation Sent',
  'On Hold',
  'Order Received',
  'No Response'
];

// Order Status Configuration
export const ORDER_STATUS = [
  'Cancel',
  'Fulfilled',
  'Payment Pending'
];

/**
 * Status Color Mapping
 * Maps each status to a color variant for the StatusChip component 
 * info, warning, success, error, default, secondary, primary
 */
export const STATUS_COLORS = {
  // Enquiry Status Colors
  'Initial Discussion Pending': 'default',
  'Require Additional Information': 'default',

  'Requested Site Visit': 'warning',
  'Follow Up Scheduled': 'warning',
  'Follow Up Missed': 'error',
  'Demo Scheduled': 'warning',
  'Demo Missed': 'error',
  'Quotation Pending': 'secondary',
  'Quotation Sent': 'success',
  'Not Interested': 'error',
  'Not Interested - Price High': 'error',
  'On Hold': 'warning',
  'No Response': 'default',

  // Quotation Status Colors
  // 'Quotation Sent': 'info',
  'Negotiation Ongoing': 'warning',
  'Revised Quotation Sent': 'info',
  'Converted': 'success',
  
  // Order Status Colors
  'Cancel': 'error',
  'Fulfilled': 'success',
  'Payment Pending': 'warning'
};

